var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',[_c('vl-layer-vector',{attrs:{"z-index":1001}},[_c('vl-source-vector',{attrs:{"features":_vm.trains}},[_c('vl-style-func',{attrs:{"function":_vm.trainStyleFactory()}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }